const LINE_HEIGHT_THRESHOLDS = {
  SMALL: 24,
  MEDIUM: 36
} as const;

const LINE_HEIGHT_INCREASE_PERCENTAGES = {
  SMALL: 20,
  MEDIUM: 15,
  LARGE: 10
} as const;

const LETTER_SPACING_INCREASE_PERCENTAGE = 3;

function increaseByPercentage(value: number, percentage: number): number {
  return (value * (percentage + 100)) / 100;
}

function getLineHeightIncreasePercentage(lineHeight: number): number {
  if (lineHeight < LINE_HEIGHT_THRESHOLDS.SMALL) {
    return LINE_HEIGHT_INCREASE_PERCENTAGES.SMALL;
  }
  if (lineHeight < LINE_HEIGHT_THRESHOLDS.MEDIUM) {
    return LINE_HEIGHT_INCREASE_PERCENTAGES.MEDIUM;
  }
  return LINE_HEIGHT_INCREASE_PERCENTAGES.LARGE;
}

function processLineHeight(element: HTMLElement, enabled: boolean): void {
  if (!element.dataset.eappsLineHeight) {
    return;
  }

  if (enabled) {
    const prevLineHeight = +element.dataset.eappsLineHeight;
    const increaseValue = getLineHeightIncreasePercentage(prevLineHeight);
    const newLineHeight = increaseByPercentage(prevLineHeight, increaseValue);

    element.style.lineHeight = `${newLineHeight}px`;
  } else {
    element.style.lineHeight = '';
  }
}

function processLetterSpacing(element: HTMLElement, enabled: boolean): void {
  const prevLetterSpacing = element.dataset.eappsLetterSpacing;

  if (!prevLetterSpacing) {
    element.style.letterSpacing = enabled ? '0.05em' : '';
    return;
  }

  if (!enabled) {
    element.style.letterSpacing = '';
    return;
  }

  const numberedPrevLetterSpacing = +prevLetterSpacing;
  const newLetterSpacing = increaseByPercentage(
    numberedPrevLetterSpacing,
    LETTER_SPACING_INCREASE_PERCENTAGE
  );

  element.style.letterSpacing = `${newLetterSpacing}px`;
}

export function applyTextSpacing(elements: HTMLElement[], enabled: boolean) {
  elements.forEach((element) => {
    const isInvalid = !(element instanceof HTMLElement) || !element.isConnected;

    if (isInvalid) {
      return;
    }

    processLineHeight(element, enabled);
    processLetterSpacing(element, enabled);
  });
}
